import React from 'react';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { IProjectAttributes } from 'shared/interfaces/IProject';
import { useStyles } from '../Project.styles';

type Props = {
  data: IProjectAttributes | undefined;
};

const ConflictsAndUsage: React.FC<Props> = ({ data }) => {
  const classes = useStyles();

  if (data === undefined) return <React.Fragment />;
  return (
    <div>
      <CustomTypography className={classes.heading}>Conflicts and Usage</CustomTypography>
      <div className={classes.flexMiniColumnContainer}>
        {data?.conflicts || data?.usage || data?.additional_provisions ? (
          <React.Fragment>
            <div>
              <CustomTypography fontSize={13} fontWeight={600}>
                Conflict : {(data?.conflicts as any)?.join(', ') || '–'}
              </CustomTypography>
              <CustomTypography fontSize={13} style={{ whiteSpace: 'break-spaces' }}>
                {data?.conflicts_details}
              </CustomTypography>
            </div>
            <div>
              <CustomTypography fontSize={13} fontWeight={600}>
                Usage / Run
              </CustomTypography>
              <CustomTypography fontSize={13}>{data?.usage || '–'}</CustomTypography>
            </div>
            <div>
              <CustomTypography fontSize={13} fontWeight={600}>
                Usage / Additional Provisions
              </CustomTypography>
              <CustomTypography fontSize={13} style={{ whiteSpace: 'break-spaces' }}>
                {data?.additional_provisions || '–'}
              </CustomTypography>
            </div>
          </React.Fragment>
        ) : (
          <CustomTypography fontSize={14}>No Conflicts and Usage Available</CustomTypography>
        )}
      </div>
    </div>
  );
};

export default ConflictsAndUsage;
